import React, { useState, useEffect } from "react";

import { classNames } from 'primereact/utils';

import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';

import axios from './axios'

const CallersTable = ({setBlocked, toast, sendMessage, notification, editable }) => {
    const [callers, setCallers] = useState([]);

    useEffect(() => {
        fetchData();
    }, []);
    
    useEffect(() => {
        if(notification.type === "caller_added"){
            fetchData()
            toast.current.show({ severity:'info', summary: 'Info', detail:`Caller ${notification.name} was added!`, life: 3000 });
        }
        else if(notification.type === "caller_edited"){
            fetchData()
            toast.current.show({ severity:'info', summary: 'Info', detail:`Caller ${notification.name} was edited!`, life: 3000 });
        }
        else if(notification.type === "caller_deleted"){
            fetchData()
            toast.current.show({ severity:'info', summary: 'Info', detail:`Caller ${notification.name} was deleted!`, life: 3000 });
        }
    }, [notification])
    
    const fetchData = async () => {
        setBlocked(true);
        try {
            const response = await axios.get('/callers');
            setCallers(response.data);
            
        } catch (err) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to get callers!', life: 3000 });
        }
        setBlocked(false);
    };

    let emptyCaller = {
        line: null,
        name: null,
        location: null,
        question: null,
    };
    
    const [submitted, setSubmitted] = useState(false);
    const [caller, setCaller] = useState(emptyCaller);
    const [addCallerDialog, setAddCallerDialog] = useState(false);
    const [deleteCallerDialog, setDeleteCallerDialog] = useState(false);

    const showAddCallerDialog = (object) => {
        setCaller(object ?? emptyCaller);
        setSubmitted(false);
        setAddCallerDialog(true);
    };

    const hideAddCallerDialog = () => {
        setSubmitted(false);
        setAddCallerDialog(false);
    };

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || '';
        let _caller = { ...caller };

        _caller[`${name}`] = val;

        setCaller(_caller);
    };

    const saveCaller = async () => {
        if (caller.name?.trim()) {
            setBlocked(true)
            if(caller.id){
                try {
                    const response_message = await axios.post('/callers/edit', caller);
                    if (response_message.data.success) {
                        fetchData()
                        setAddCallerDialog(false)
                        sendMessage(JSON.stringify({type: "caller_edited", name: caller.name }))
                        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Caller edited!', life: 3000 });
                    }
                    else {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Caller failed to edit!', life: 3000 });
                    }
                }
                catch (error) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Caller failed to edit!', life: 3000 });
                }
            }
            else {
                try {
                    const response_message = await axios.post('/callers/add', caller);
                    if (response_message.data.success) {
                        fetchData()
                        setAddCallerDialog(false)
                        sendMessage(JSON.stringify({type: "caller_added", name: caller.name }))
                        toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Caller added!', life: 3000 });
                    }
                    else {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Caller failed to add!', life: 3000 });
                    }
                }
                catch (error) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Caller failed to add!', life: 3000 });
                }
            }
            setBlocked(false)
        }
        setSubmitted(true)
    };

    const addCallerDialogFooter = (
        <React.Fragment>
            <Button label="Cancel" icon="pi pi-times" outlined onClick={hideAddCallerDialog} />
            <Button label="Save" icon="pi pi-check" onClick={saveCaller} className="m-0" />
        </React.Fragment>
    );

    const hideDeleteCallerDialog = () => {
        setDeleteCallerDialog(false);
    };

    const showDeleteCallerDialog = (object) => {
        setCaller(object);
        setDeleteCallerDialog(true)
    }

    const deleteCaller = async () => {
        setBlocked(true)
        try {
            const response_message = await axios.post('/callers/delete', caller);
            if (response_message.data.success) {
                fetchData()
                setDeleteCallerDialog(false)
                sendMessage(JSON.stringify({type: "caller_deleted", name: caller.name}))
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Caller deleted!', life: 3000 });
            }
            else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Caller failed to delete!', life: 3000 });
            }
        }
        catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Caller failed to delete!', life: 3000 });
        }
        setBlocked(false)
    }

    const deleteCallerDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" outlined onClick={hideDeleteCallerDialog} />
            <Button label="Yes" icon="pi pi-check" severity="danger" onClick={deleteCaller} />
        </React.Fragment>
    );

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="flex align-items-center justify-content-end gap-2">
                <Button icon="pi pi-pencil" severity="info" aria-label="Edit" size='small' onClick={(e) => showAddCallerDialog(rowData)} />
                <Button icon="pi pi-times" severity="danger" aria-label="Cancel" size='small' onClick={(e) => { showDeleteCallerDialog(rowData)}} />
            </div>
        );
    };

    return (
        <>
            <DataTable value={callers} scrollable scrollHeight="flex" className="text-lg" emptyMessage="No callers">
                <Column field="line" header="Line"></Column>
                <Column field="name" header="Name"></Column>
                <Column field="location" header="Location"></Column>
                <Column field="question" header="Question"></Column>
                {editable && <Column header={<Button label="Add Caller" icon="pi pi-plus" severity="success" onClick={(e) => showAddCallerDialog(null)} size="small" />} body={actionBodyTemplate} align={"right"}></Column>}
            </DataTable>

            <Dialog visible={addCallerDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Caller Details" modal className="p-fluid" footer={addCallerDialogFooter} onHide={hideAddCallerDialog} draggable={false}>
                <div className="field">
                    <label htmlFor="line" className="font-bold">
                        Line
                    </label>
                    <InputText id="line" value={caller.line} onChange={(e) => onInputChange(e, 'line')} required autoFocus className={classNames({ 'p-invalid': submitted && !caller.name })} />
                    {submitted && !caller.line && <small className="p-error">Line is required.</small>}
                </div>
                <div className="field">
                    <label htmlFor="name" className="font-bold">
                        Name
                    </label>
                    <InputText id="name" value={caller.name} onChange={(e) => onInputChange(e, 'name')} required className={classNames({ 'p-invalid': submitted && !caller.name })} />
                    {submitted && !caller.name && <small className="p-error">Name is required.</small>}
                </div>
                <div className="field">
                    <label htmlFor="location" className="font-bold">
                        Location
                    </label>
                    <InputText id="location" value={caller.location} onChange={(e) => onInputChange(e, 'location')} />
                </div>
                <div className="field">
                    <label htmlFor="question" className="font-bold">
                        Question
                    </label>
                    <InputText id="question" value={caller.question} onChange={(e) => onInputChange(e, 'question')} />
                </div>
            </Dialog>

            <Dialog visible={deleteCallerDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm" modal footer={deleteCallerDialogFooter} onHide={hideDeleteCallerDialog} draggable={false}>
                <div className="confirmation-content">
                    {caller && <span>Are you sure you want to delete the selected caller?</span>}
                </div>
            </Dialog>
        </>
    )
}

export default CallersTable;